<div (keydown)="handleKeyDown($event)" tabindex="0">
  <rt-redactor-inserts-dropdown-header
    [hasBackAction]="hasBackAction"
    [hasSearch]="state.emailTemplates.length > 5"
    [hasSettings]="true"
    [searchQuery]="state.searchQuery"
    [searchPlaceholder]="'app.common.placeholders.search.email_templates.other' | translate"
    [label]="'app.redactor_inserts.email_templates.dropdown.heading' | translate"
    (focusChanges)="onFocusChanges($event)"
    (searchQueryChange)="onSearchQueryChange($event)"
    (goBack)="goBack()"
    (goToSettings)="
      goToPage(
        kind === InsertsEmailKind.EmailTemplate
          ? 'settings/emails/general'
          : 'settings/emails/event_invitation'
      )
    "
    (closeDropdown)="closeDropdown.emit()"
  >
  </rt-redactor-inserts-dropdown-header>
  @if (!insideTemplate) {
    @if (state.emailTemplateGroups.length > 0) {
      <div class="group-container">
        @for (
          emailTemplateGroup of state.emailTemplateGroups;
          track groupsTrackByFn($index, emailTemplateGroup)
        ) {
          <div>
            <rt-dropdown-header [isSubheading]="true">
              {{ emailTemplateGroup.groupName }}
            </rt-dropdown-header>

            @for (
              template of emailTemplateGroup.groupedEmailTemplates;
              track templatesTrackByFn(index, template);
              let index = $index
            ) {
              <rt-dropdown-item
                #eleRef
                [highlighted]="state.selectedId === template.id"
                (click)="emailTemplateChoose.emit(template)"
                [attr.data-id]="template.id"
              >
                {{ template.title }}
              </rt-dropdown-item>
            }
          </div>
        }
      </div>
      <rt-divider></rt-divider>
      @if (InsertsEmailKind.EventInvitation === kind && (canManageTemplates$ | ngrxPush)) {
        <rt-dropdown-item [noDivider]="true" (click)="saveAsTemplate.emit()">
          <rt-icon prefix name="playlist-add"></rt-icon>
          {{ 'app.email_templates.event_invitation_inserts.save_as_template' | translate }}
        </rt-dropdown-item>
      }
    }

    @if (state.emailTemplates.length === 0) {
      <rt-empty-state
        [title]="'app.redactor_inserts.email_templates.dropdown.empty_state_title' | translate"
        [desc]="'app.redactor_inserts.email_templates.dropdown.empty_state_desc' | translate"
        variant="small"
        class="empty-state"
        padding-lr
      >
        <rt-button (click)="goToPage('settings/emails')" variant="primary">
          {{ 'app.redactor_inserts.email_templates.dropdown.manage_templates' | translate }}
        </rt-button>
      </rt-empty-state>
    }

    @if (state.emailTemplateGroups.length === 0 && state.emailTemplates.length !== 0) {
      <rt-empty-state
        [title]="'app.redactor_inserts.email_templates.dropdown.no_filtered_title' | translate"
        [desc]="'app.redactor_inserts.email_templates.dropdown.no_filtered_desc' | translate"
        variant="small"
        class="empty-state"
        padding-lr
      >
      </rt-empty-state>
    }
  }

  @if (insideTemplate) {
    <ng-container *ngTemplateOutlet="insideTemplate"> </ng-container>
  }
</div>
